import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import { initSentry } from '@shared/js/sentry';

// base
import App from '@js/analysis/App.vue';
import router from '@js/analysis/router';
import store from '@js/store';
import { initApi } from '@videotools/js/api/initApi';

// mixins and directives
import * as transMixin from '@js/mixins/transHelpers';
import * as debugMixin from '@js/mixins/debug';
import * as rafMixin from '@js/mixins/raf';
import * as confirmDialog from '@js/extend/confirm-dialog';
import directives from '@js/directives';

// extra
import $I18n from '@js/i18n';
import VueDragscroll from 'vue-dragscroll';

Vue.prototype.$I18n = $I18n;
window.openModals = [];

const init = () => {
	initApi(store);
	// register directives and mixins
	Vue.use(transMixin);
	Vue.use(debugMixin);
	Vue.use(rafMixin);
	Vue.use(confirmDialog);
	Vue.use(VueDragscroll);

	for (const directive of directives) {
		directive.register();
	}

	// register plugins
	Vue.use(Vue2TouchEvents);

	initSentry('TaggingTool');

	return new Vue({
		el:     '#analysis',
		store,
		router,
		render: (h) => h(App),
	});
};

export { init };
